require('../../modules/es6.object.assign');
module.exports = require('../../modules/_core').Object.assign;



//////////////////
// WEBPACK FOOTER
// D:/xampp_bk/htdocs/xampp/organicshop/~/core-js/library/fn/object/assign.js
// module id = ../../../../core-js/library/fn/object/assign.js
// module chunks = 3